
  import {
    Component,
    Vue,
    Prop,
    Model
  } from 'vue-property-decorator'

  @Component({
    name: 'radio-button'
  })
  export default class RadioButton extends Vue {
    // private activeIndex = 0;
    @Prop({}) private list!: any;
    @Prop({}) private label!: string;
    @Prop({}) private val!: string;
    @Prop({default:false}) private disabled!: boolean;
    @Model('input') value!: any;

    private handleClick(val: any) {
      if (val === this.value || this.disabled) return;
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
